import React from 'react';
import LogoOne from '../../assets/LogoOne.png';
import './Header.scss';

const Header = () => {
  return(
    <div className="d-flex flex-column container-fluid p-0">
      <header>
        <nav>
          <img className="m-2 p-2" src={LogoOne} height="50px" alt="" />
        </nav>
      </header>
    </div>
  );
};
export default Header;
